ScoreTrekBattle.Settings = (function() {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            active: false,
            $view: null
        };
    }
    resetStatus();

    function onViewRender() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.View.updateMenu(`/settings`);
            ScoreTrekBattle.Template.render('settings/settings').then(view => {
                STATUS.active = true;
                STATUS.$view = view.$view;
                resolve(STATUS.$view);
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            resolve();
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    _this = {
        toggleFavorite: function(favoriteType, refId, isFavorite) {
            if (favoriteType === 'tournament') {
                $(`[data-tournament-id="${refId}"]`).attr('data-tournament-is-favorite', isFavorite ? 'yes' : 'no');
            } else if (favoriteType === 'matchday') {
                $(`[data-matchday-id="${refId}"]`).attr('data-matchday-is-favorite', isFavorite ? 'yes' : 'no');
            } else if (favoriteType === 'series') {
                $(`[data-series-id="${refId}"]`).attr('data-series-is-favorite', isFavorite ? 'yes' : 'no');
            } else if (favoriteType === 'club') {
                $(`[data-club-id="${refId}"]`).attr('data-club-is-favorite', isFavorite ? 'yes' : 'no');
            } else {
                console.warn(`Unknown favorite type: ${favoriteType}`);
                return;
            }

            ScoreTrekBattle.Event.trigger('favorite.changed', [favoriteType, refId, isFavorite]);
        },

        getShareRefName: function(shareType, refId) {
            if (shareType === 'tournament') {
                return ScoreTrekBattle.Tournament.getCurrentName(refId);
            } else if (shareType === 'matchday') {
                return ScoreTrekBattle.League.Matchday.Details.getCurrentName(refId);
            } else if (shareType === 'matchdays') {
                return ScoreTrekBattle.League.Matchdays.getCurrentName();
            } else if (shareType === 'tournaments') {
                return ScoreTrekBattle.Tournament.List.getCurrentName();
            } else if (shareType === 'statistics') {
                return ScoreTrekBattle.Statistics.getCurrentName(refId);
            } else if (shareType === 'series') {
                return ScoreTrekBattle.Series.getCurrentName(refId);
            } else if ((shareType === 'club') || (shareType === 'clubSeries') || (shareType === 'clubMatchdays')) {
                return ScoreTrekBattle.Club.getCurrentName(refId);
            } else {
                console.warn(`Unknown share type: ${shareType}`);
                return '';
            }
        },

        getShareUrl: function(shareType, refId, hashOnly) {
            let urlHash;

            if (shareType === 'tournament') {
                urlHash = ScoreTrekBattle.Tournament.getShareHash(refId);
            } else if (shareType === 'matchday') {
                urlHash = ScoreTrekBattle.League.Matchday.Details.getShareHash(refId);
            } else if (shareType === 'matchdays') {
                urlHash = ScoreTrekBattle.League.Matchdays.getShareHash();
            } else if (shareType === 'tournaments') {
                urlHash = ScoreTrekBattle.Tournament.List.getShareHash();
            } else if (shareType === 'statistics') {
                urlHash = ScoreTrekBattle.Statistics.getShareHash(refId);
            } else if (shareType === 'series') {
                urlHash = ScoreTrekBattle.Series.getShareHash(refId);
            } else if ((shareType === 'club') || (shareType === 'clubSeries') || (shareType === 'clubMatchdays')) {
                urlHash = ScoreTrekBattle.Club.getShareHash(refId, shareType);
            } else {
                console.warn(`Unknown share type: ${shareType}`);
                urlHash = '';
            }
            return hashOnly ? `${urlHash}` : `https://${location.host}${urlHash}`;
        }
    };

    
    addEventListener("DOMContentLoaded", () => {
        ScoreTrekBattle.View.register('/settings', () => { return onViewRender(); }, onViewLoad, onViewUpdate, onViewUnload);
    });

    ScoreTrekBattle.Event.on('action.rating.recalculate', function() {
        chmDialog.confirm('Recalculate all player ratings now?', {
            title: 'Recalculate Ratings',
            buttonYes: 'Recalculate',
            buttonNo: 'Cancel'
        }).then(() => {
            ScoreTrekBattle.View.loading('Settings.recalculateRatings', true);
            Api.request('/rating/recalculate').catch(error => {
                chmDialog.error(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Settings.recalculateRatings', false);
            });
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.monitor.codes', function() {
        ScoreTrekBattle.View.loading('Settings.loadMonitorCodes', true);

        Api.request('/monitor/codes').then(result => {
            let groups, $codes;

            if (!Array.isArray(result.codes)) {
                chmDialog.error('No codes.');
                return;
            }

            groups = {};

            result.codes.forEach(codeEntry => {
                if (!groups[codeEntry.type]) {
                    groups[codeEntry.type] = [];
                }
                groups[codeEntry.type].push(`<tr><td style="padding-right:1rem;" class="color-blue">${codeEntry.value}</td><td style="font-family:monospace;" class="color-yellow">${codeEntry.code}</td></tr>`);
            });

            $codes = $('<table>');

            Object.keys(groups).forEach(groupName => {
                $codes.append(`<tr><th colspan="2" style="text-align:left;">${String(groupName).toUpperCase()}</th></tr>`);
                $codes.append(groups[groupName].join(''));
            });

            if (result.codes.length === 0) {
                $codes.append('<tr><td colspan="2" class="color-white-50"><i class="fa-solid fa-inbox"></i> No recent codes.</td></tr>');
            }

            chmDialog.info($codes);
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Settings.loadMonitorCodes', false);
        });
    });

    return _this;
})();